import { combineReducers } from 'redux';
import { OrderManagementDetailConfig } from './order-detail';
import { OrderManagementModificationConfig } from './order-modification';

export const OM_STATE_REDUCERS = combineReducers({
  [OrderManagementDetailConfig.name]: OrderManagementDetailConfig.reducer,
  [OrderManagementModificationConfig.name]:
    OrderManagementModificationConfig.reducer,
});
